import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ISprayingHour } from 'src/app/core/models/interfaces/spraying-hours';

@Component({
  selector: 'spraying-hours-arc',
  templateUrl: './sprayin-hours-arc.component.html',
  styleUrls: ['./sprayin-hours-arc.component.scss'],
})
export class SprayinHoursArcComponent implements OnInit, OnChanges {

  @Input() sprayingData: Array<ISprayingHour>
  currentHour
  currentDetail: "spraying-hours.suitable" | "spraying-hours.risky" = "spraying-hours.suitable"
  constructor() { }
  ngOnChanges(changes: SimpleChanges): void {
    this.init()
  }

  ngOnInit() {}

  ionViewDidEnter() {
    this.init()
  }

  init() {
    let currentHour = new Date().getHours();
    this.currentHour = currentHour < 10 ? `0${currentHour}:00` : `${currentHour}:00`
    this.sprayingData.forEach(el => {
      let id = el.Hour < 10 ? `0${el.Hour}00` : `${el.Hour}00`
      let color = el.IsAvailable ? "#7CD353" : "#DADADA"
      let doc: any = document.getElementById(id)
      if (doc) {
        doc.style.fill = color 
      }
      if (el.Hour == currentHour) {
        doc.style.fill = color
        this.currentDetail = el.IsAvailable ? "spraying-hours.suitable" : "spraying-hours.risky"
        document.getElementById("inner-circle").style.fill = color
        document.getElementById("outer-circle").style.fill = color 
        document.getElementById("sun_"+id).style.display = "unset"
      }
    });
  }

}
